<script setup lang="ts">
const benefits = [
  {
    title: 'Banyak Pilihan Ekspedisi',
    description:
      'Berbagai ekspedisi ternama telah bergabung dan mendukung pembayaran COD.',
    icon: 'material-symbols:verified-outline',
    iconSize: '33px'
  },
  {
    title: 'COD Tanpa Marketplace',
    description:
      'Membantu penjualanmu dengan pembayaran COD tanpa memerlukan marketplace.',
    icon: 'material-symbols:account-balance-wallet-outline',
    iconSize: '33px'
  },
  {
    title: 'Pencairan Dana COD Cepat',
    description:
      'Arus kas tetap lancar dengan proses rilis dana COD yang cepat dan efisien.',
    icon: 'material-symbols:credit-card-outline',
    iconSize: '33px'
  }
]
</script>

<template>
  <section class="bg-surface-container-low">
    <UiContainer class="py-12 flex flex-col gap-6 lg:gap-16">
      <h2
        class="text-2xl leading-7 lg:text-4xl font-bold lg:text-center text-on-secondary-container font-display"
      >
        Keunggulan Pembayaran COD di KiriminAja
      </h2>
      <div class="grid grid-cols-1 gap-6 lg:grid-cols-3">
        <UiCardFeature
          v-for="(benefit, index) in benefits"
          :key="index"
          :icon="benefit.icon"
          :icon-size="benefit.iconSize"
          :title="benefit.title"
          :description="benefit.description"
        />
      </div>
    </UiContainer>
  </section>
</template>
